import { Tab as ChakraTab, TabPanel } from '@chakra-ui/react';
import { useQuoteLineContext } from '@ui/features/quote-builder/components/QuoteLine/QuoteLineProvider';
import { actions } from '@ui/features/quote-builder/state/reducer';
import { QuoteInfoTab } from '@ui/features/quote-builder/types/state/quote-line';
import { useDispatch } from '@ui/hooks/useDispatch';

import { TabComponentType } from '../types';
import { CostEstimator as CostEstimatorComponent } from './CostEstimator';

const tab = QuoteInfoTab.CostEstimator;

function Tab() {
  const dispatch = useDispatch();
  const { quoteLineUuid } = useQuoteLineContext();

  function handleTabChange() {
    dispatch(actions.quoteLineInfoTabChanged({ quoteLineUuid, tab }));
  }

  return <ChakraTab onClick={handleTabChange}>Cost Estimator</ChakraTab>;
}

function Panel() {
  return (
    <TabPanel>
      <CostEstimatorComponent />
    </TabPanel>
  );
}

export const CostEstimator = {
  tab,
  Tab,
  Panel,
} satisfies TabComponentType;
